<template>
	<div class="subject-audit-detail">
		<div class="container-fluid">
			<!-- Begin page -->
			<div class="wrapper">
				<div class="content-page content-subProject">
					<div class="content">
						<div class="row">
							<div class="col-12">
								<div class="page-title-box">
									<div class="page-title-right"><Breadcrumb /></div>
									<h3 class="header-title mb-3">区级审核详情</h3>
								</div>
								<!-- end page-title-box -->
							</div>
						</div>

						<div class="row">
							<div class="col-12">
								<div class="card">
									<div class="card-body">
										<div class="card-reviewDetails">
											<h3 class="text-center">{{ topicInfo.title }}</h3>
											<div class="row row-reviewDetails">
												<div class="col-6 col-md-3">申报人：{{ topicInfo.userName }}</div>
												<div class="col-6 col-md-3">所属单位：{{ topicInfo.unit }}</div>
												<div class="col-6 col-md-3">主要参与者：{{ topicInfo.record }}</div>
												<div class="col-6 col-md-3">联系电话：{{ topicInfo.phone }}</div>
												<div class="col-6 col-md-3">学段：{{ topicInfo.learningSectionString }}</div>
												<div class="col-6 col-md-3">学科：{{ topicInfo.disciplineIdString }}</div>
												<div class="col-6 col-md-3">上传时间：{{ topicInfo.createTime }}</div>
												<div class="col-12">简介：{{ topicInfo.introduction }}</div>
											</div>
											<!-- 在线开题报告 -->
											<div class="view">
												<div class="view-div">
													<div v-for="(item, index) in topicInfo.list" :key="index" :style="{ color: tabIndex == index ? '#3081ea' : '' }">
														<h4 style="margin-right: 40px;" @click="preview(item, index)">{{ item.value }}</h4>
													</div>
												</div>
												<iframe
													v-if="isFileType"
													:src="urlFile"
													frameborder="0"
													style="height: 700px;width: 100%;border: 1px solid #eeeeee;text-align: center;"
												></iframe>
												<div v-else style="height: 700px;width: 100%;border: 1px solid #eeeeee;text-align: center;">
													<video
														ref="previewVideo"
														style="width: 100%;height: 700px;"
														autoplay
														controls
														v-if="curPreviewFileType == 'video'"
														:src="curPreviewFileUrl"
													></video>
												</div>
											</div>
											<!-- 审核意见列表 -->
											<div class="comments-list" style="margin-top: 10vh;">
												<div class="form-group row mb-2" v-for="(item, index) in topicInfo.schoolAuditList" :key="item.id">
													<label class="col-md-2 col-12 col-form-label" style="text-align: right;">
														{{ item.auditType == 2 ? '学校审核' + (index + 1) : '区级审核' + (index + 1) }}
													</label>
													<div class="col-md-9 col-10">
														<table class="table table-bordered table-centered mb-0">
															<tbody>
																<tr>
																	<th style="width: 90px;">审核意见</th>
																	<td>{{ item.auditState == 2 ? '通过' : '不通过' }}</td>
																	<th>审核人</th>
																	<td>{{ item.auditName }}</td>
																	<th>审核时间</th>
																	<td>{{ item.createTime | getTime }}</td>
																</tr>
																<tr>
																	<th style="width: 90px;">审核说明</th>
																	<td colspan="5">{{ item.auditExplain }}</td>
																</tr>
															</tbody>
														</table>
													</div>
													<div class="col-md-1 col-2"><span class="required"></span></div>
												</div>
											</div>

											<div style="display: flex;align-items: center;" v-if="showTitle">
												<h4>是否通过：</h4>
												<el-radio v-model="autoState" :label="2">通过</el-radio>
												<el-radio v-model="autoState" :label="1">退回修改</el-radio>
											</div>
											<div v-if="showTitle">
												<h4>审批描述：</h4>
												<el-input type="textarea" :rows="4" v-model="auditExplain"></el-input>
											</div>

											<div class="text-center" style="margin-top: 5vh;">
												<el-button @click="submitBtn" type="primary" v-if="showTitle">确定</el-button>
												<button type="button" class="btn btn-light" style="margin-left: 20px;" @click="goBack">返 回</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- end wrapper-->
			<el-dialog :title="curPreviewFileDialogTitle" :visible.sync="filePreviewDialogVisible" width="50%" :before-close="handleClose">
				<div class="preview_wrap">
					<el-image
						style="width: 90%; height: 90%"
						v-if="curPreviewFileType == 'pic'"
						:src="curPreviewFileUrl"
						:preview-src-list="[curPreviewFileUrl]"
						fit="scale-down"
						:z-index="3000"
					></el-image>
					<video ref="previewVideo" style="width: 500px;height: 400px;" autoplay controls v-if="curPreviewFileType == 'video'" :src="curPreviewFileUrl"></video>
				</div>

				<span slot="footer" class="dialog-footer"><el-button @click="closePreviewFileDialog">关闭</el-button></span>
			</el-dialog>
		</div>
	</div>
</template>

<script>
import { schoolAudit, getApiReviewInfo } from '@/api/after/newInterface.js';
import Breadcrumb from '@/views/backstage/components/Breadcrumb.vue';
export default {
	components: {
		Breadcrumb
	},
	data() {
		return {
			filePreviewDialogVisible: false,
			curPreviewFileDialogTitle: '',
			curPreviewFileType: '', //当前预览文件类型
			curPreviewFileUrl: '', //当前预览文件URL
			topicInfo: {}, //课题信息
			titleArr: [],
			tabIndex: 0,
			autoState: null,
			auditExplain: null,
			showTitle: true,
			isFileType: true,
			urlFile: ''
		};
	},
	filters: {
		getMember(val) {
			if (val) {
				return val.replace(/,/g, '、');
			}
		},
		formatFileType(val) {
			switch (val) {
				case 'pic':
					return '图片';
					break;
				case 'doc':
					return '文档';
					break;
				case 'docx':
					return '文档';
					break;
				case 'video':
					return '视频';
					break;
				case 'other':
					return '其他文件';
					break;
				default:
			}
		}
	},
	async mounted() {
		this.showTitle = this.$route.query.showTitle ? false : true;
		await this.getInfo();
		// // 数据请求成功之后渲染pdf
	},
	methods: {
		submitBtn() {
			if (this.autoState == null) {
				this.$message.error('请选择审核状态');
				return;
			}
			if (this.autoState == 0 && this.auditExplain == null) {
				this.$message.error('请填写审批描述');
				return;
			}
			let params = {
				auditType: this.$route.query.auditType,
				declareId: this.$route.query.id,
				auditState: this.autoState,
				auditExplain: this.auditExplain,
				type: 2
			};
			schoolAudit(params).then(res => {
				if (res.code == 200) {
					this.$message.success('操作成功');
					this.$router.go(-1);
				} else {
					this.$message.error(res.data);
				}
			});
		},
		// 关闭文件预览对话框
		closePreviewFileDialog() {
			this.filePreviewDialogVisible = false;
			if (this.curPreviewFileType === 'video') {
				this.$refs.previewVideo.pause();
			}
		},
		// 打开预览文件对话框
		preview(item, index = 0) {
			this.tabIndex = index;
			if (item.fileType == 'video') {
				this.curPreviewFileType = 'video';
				this.curPreviewFileUrl = `${this.uploadUrl}/upload/previewVideo/${item.id}`;
				this.isFileType = false;
			} else {
				this.isFileType = true;
				// let file = `http://yiwu.mengning.xyz${item.url}`;
				let file = `${this.uploadFile}${item.url}`;
				let xurl = 'https://view.xdocin.com/xdoc?_xdoc=';
				xurl += encodeURIComponent(file);
				let ops = {
					pdf:true,
					img: false,
					ppt: true,
					pptx: true,
					pic: true,
					fontsize: '18',
					xls: true,
					xlsx: true,
					zip: true,
					jpg: true,
					png: true
				};
				for (let a in ops) {
					xurl += '&' + a + '=' + encodeURIComponent(ops[a]);
				}
				if (item.url) {
					//开始预览
					this.urlFile = xurl;
				} else {
					this.urlFile = '';
				}
			}
		},
		// 征文详情
		getInfo() {
			getApiReviewInfo(this.$route.query.id).then(res => {
				this.topicInfo = res.data;
				if (this.topicInfo.list) {
					this.topicInfo.list.forEach(item1 => {
						let name = item1.name1 ? item1.name1.slice(0, -4) : null;
						this.$set(item1, 'name', name);
					});
					let arr = this.topicInfo.list.filter(item => item.id);
					this.preview(arr[0]);
				}
				console.log(this.topicInfo.schoolAuditList,'this.topicInfo.schoolAuditList');
			});
		},
		goBack() {
			this.$router.go(-1);
		},

		handleClose(done) {
			this.$confirm('确认关闭？')
				.then(_ => {
					done();
				})
				.catch(_ => {});
		}
	}
};
</script>

<style scoped lang="scss">
.view_report {
	margin-top: 50px;
}
.preview_wrap {
	height: 100%;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
}
.file_list {
	border-bottom: 1px solid #ccc;
	.file_list_title {
		font-size: 18px;
		font-weight: bolder;
		margin-bottom: 15px;
	}
	.file_item {
		display: flex;
		align-items: center;
		margin-bottom: 10px;
		cursor: pointer;
		.file_type {
			font-size: 18px;
			font-weight: bolder;
			margin-right: 20px;
		}
	}
	.file_item:hover {
		color: #006dcc;
	}
}
.view {
	width: 1000px;
	height: 700px;
}
.comments-list {
	margin-top: 20px;
}
.file-list {
	width: 100%;
	display: flex;
	justify-content: center;
	padding-left: 0;
	list-style: none;
	.file-item {
		font-size: 24px;
		text-align: center;
		width: 50%;
		border-bottom: 2px solid #eee;
		cursor: pointer;
	}
}
.file-item.active {
	border-color: #00a2e8;
}
.view-div {
	display: flex;
	align-items: center;
	justify-content: center;
}
.view-tit {
	font-weight: 700;
	width: 150px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	-o-text-overflow: ellipsis;
	cursor: default;
	font-size: 1.2rem;
}
.active {
	color: #006dcc !important;
}
</style>
